var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapMarker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.14 5.42a5.666 5.666 0 00-8.773-4.18A5.707 5.707 0 00.86 5.42 5.64 5.64 0 002.5 9.973l3.533 3.54a.666.666 0 00.947 0l3.52-3.54a5.638 5.638 0 001.64-4.553zM9.567 9.033L6.5 12.1 3.433 9.033a4.327 4.327 0 01-1.246-3.48 4.38 4.38 0 011.926-3.22 4.313 4.313 0 016.096 1.388c.334.554.54 1.175.604 1.819a4.327 4.327 0 01-1.246 3.493zM6.5 3a3 3 0 103 3 3.007 3.007 0 00-3-3zm0 4.667a1.667 1.667 0 110-3.334 1.667 1.667 0 010 3.334z",
    fill: "#8A9AA7"
  })));
}
export default SvgMapMarker;